import { LoadingButton } from "@mui/lab";
import { Card, CardContent, Grid } from "@mui/material";
import { useSnackbar } from "notistack";
import { TextField } from "../../../components/Form";
import { useStudioForm } from "../../../components/Form/hooks";
import { useCreateGroup } from "../../../domain/crud";
import { makeGroupLocation, useStudioNavigate } from "../../../paths";
import { createGroupSchema } from "./validation";

export default function GroupForm() {
  const navigate = useStudioNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const createGroup = useCreateGroup();

  const { control, handleSubmit } = useStudioForm({
    schema: createGroupSchema,
    defaultValues: {
      name: null,
    },
    onSubmit(values) {
      createGroup.mutate(values, {
        onSuccess(response) {
          navigate(makeGroupLocation(response.data.id));
        },
        onError() {
          enqueueSnackbar("Unable to create group", { variant: "error" });
        },
      });
    },
  });

  return (
    <Card>
      <CardContent>
        <Grid component="form" container onSubmit={handleSubmit} spacing={2}>
          <Grid item xs={3}>
            <TextField control={control} name="name" />
          </Grid>
          <Grid item xs={12}>
            <LoadingButton
              loading={createGroup.isLoading}
              type="submit"
              variant="contained"
            >
              Create
            </LoadingButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
